<div class="flex-direction-column gap-5">
  @if(isCheckbox) {
    <mat-checkbox [(ngModel)]="value"></mat-checkbox>
  } @else if(isDateRange) {
    <div class="form-field-container date-range-container"
         [ngClass]="classe"
         [style.width]="widthFormField"
         [style.height]="heightFormField"
         [style.top]="top"
         [style.left]="left"
         [style.position]="(top || left) ? 'absolute' : null">
      <mat-date-range-input [rangePicker]="picker" [disabled]="disabled">
        <input matStartDate
               [(ngModel)]="dataInicio"
               (ngModelChange)="change()"
               (focusout)="focusOut()"
               placeholder="Data Inicial"
               name="dataInicio"
               required>
        <input matEndDate
               [(ngModel)]="dataFim"
               (ngModelChange)="change()"
               (focusout)="focusOut()"
               placeholder="Data Final"
               name="dataFim"
               required>
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </div>
  } @else {
    <div class="form-field-container"
         [ngClass]="classe"
         [style.width]="widthFormField"
         [style.height]="heightFormField"
         [style.background-color]="classe !== 'login' ? backgroundColor : null"
         [style.border-radius]="classe !== 'login' ? borderRadius : null"
         [style.border-width]="classe !== 'login' ? borderWidth : null"
         [style.border-color]="isInvalid ? '#f44336' : (classe !== 'login' ? (borderColor ?? 'transparent') : null)"
         [style.top]="top"
         [style.left]="left"
         [style.position]="(top || left) ? 'absolute' : null">
      @if(iconPrefix) {
        <mat-icon class="icon-prefix" [style.color]="classe !== 'login' ? (iconColor ?? 'black') : null">{{ iconPrefix }}</mat-icon>
      }
      <input
        #internalInput
        class="form-input"
        [style.font-size]="font"
        [name]="type"
        [autocomplete]="type"
        [type]="type"
        [min]="min"
        [maxlength]="max"
        [disabled]="disabled"
        [attr.maxlength]="maxLengthFormFiles ? maxLengthFormFiles : null"
        [placeholder]="placeholder"
        [(ngModel)]="value"
        [class.invalid]="isInvalid"
        (focusout)="focusOut()"
        (ngModelChange)="change()"
        (keydown.enter)="handleEnterKey()">
      @if(isSenha) {
        <button type="button" class="icon-button" [style.color]="classe !== 'login' ? (iconColor ?? 'black') : null" (click)="toggleMostrarSenha()">
          <mat-icon>{{ iconSuffixSenha }}</mat-icon>
        </button>
      } @else if(iconSuffix) {
        <mat-icon class="icon-suffix" [style.color]="classe !== 'login' ? (iconColor ?? 'black') : null">{{ iconSuffix }}</mat-icon>
      }
    </div>
  }
  @if (showValidationErrors && isInvalid) {
    <div class="error-message">
      {{ getErrorMessage() }}
    </div>
  }
</div>
